import React, { useRef, useEffect, useState, useContext } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { useRecoilState } from 'recoil';
import { SortChangedEvent } from 'ag-grid-community';
import LZString from 'lz-string';
import {
  useGetColumnDefs,
  updateAllColDefs,
  updateColDefs,
  updateSortFieldRequest,
  wrapperDataReturnDataForUnitTest
} from '../../ultils';
import { frameworkComponents } from '../cell-render';
import searchRequestAtom from '../../recoils/useSearchRequest/searchRequestAtom';
import {
  COL_DEF_CHECK_BOX_OFF,
  COL_DEF_SET_CHECKBOX,
  REVERSE_SEARCH_GRID_OPTIONS
} from '../../constants';
import selectedCheckboxsAtom from '../../recoils/useSelectedCheckboxsReverseSearch/selectedCheckboxsAtom';
import useDragColumnChange from '../../hooks/useDragColumnChange';
import { AuthContext } from '../../context/UserContext'
import { VerticalViewTable } from '../vertical-ui-ag-grid-table';

interface IProp {
  rowData: any;
  columnDefs: any;
  pinRowData: any;
  currentUrl: string;
  updateUrl: (decodedParam: string) => void;
  onFirstDataRendered?: (event: any) => void;
  isReverse?: any;
  setIsOrderByColumn: (isOrderByColumn: boolean) => void;
  keyState: string;
  isOrderByColumn: boolean;
  isHorizontalView: boolean;
}



export const ReverseAgTable: React.FC<IProp> = ({
  rowData,
  columnDefs,
  pinRowData,
  currentUrl,
  updateUrl,
  onFirstDataRendered,
  isReverse,
  setIsOrderByColumn,
  keyState,
  isOrderByColumn,
  isHorizontalView
}) => {
  const [boxCheck, setBoxCheck] = useState<number>(0);
  const [listCheckbox] = useRecoilState(selectedCheckboxsAtom);
  const [searchQuery, setSearchQuery] = useRecoilState(searchRequestAtom);
  const appliedColumn = useRef<any>();
  const columnApiRef = useRef<any>(null);
  const { userData } = useContext(AuthContext);
  // ! for save state to local storage startconst 

  const columnDefsFixed = useGetColumnDefs();

  const { onDragStarted, onDragStopped } = useDragColumnChange(
    keyState,
    currentUrl,
    updateUrl,
    setIsOrderByColumn,
    userData.IsLoggedIn
  );
  // ! for save state to local storage ends
  const exceptColDef = columnDefsFixed.map((col: any) => {
    if (col.field === 'seriesName' || col.field === 'manufacturerProductNumber') {
      return false;
    }
    return col.field;
  });

  const colDefs = columnDefs.filter((col: any) => {
    return col.field !== 'crossType.crossName';
  });
  const updateColDefForReverse = updateAllColDefs(
    colDefs,
    COL_DEF_SET_CHECKBOX,
    exceptColDef
  );
  appliedColumn.current = updateColDefs(
    updateColDefForReverse,
    COL_DEF_CHECK_BOX_OFF
  );

  const handleSortChange = (e: SortChangedEvent) => {
    let updateRequest = { ...searchQuery };
    const columnDefsState = wrapperDataReturnDataForUnitTest(
      e?.columnApi?.getColumnState()
    );
    const colSorted = columnDefsState.filter((obj: any) => {
      return obj.sort !== null;
    });
    // For updating search request - sortFilter field
    switch (colSorted[0].colId) {
      case 'manufacturerProductNumber':
        updateRequest = updateSortFieldRequest(
          updateRequest,
          colSorted[0],
          'Manufacturer'
        );
        break;
      case 'packageTypeCellRenderer':
        updateRequest = updateSortFieldRequest(
          updateRequest,
          colSorted[0],
          'Packaging'
        );
        break;
      case 'quantityAvailable':
        updateRequest = updateSortFieldRequest(
          updateRequest,
          colSorted[0],
          'QuantityAvailable'
        );
        break;
      case 'unitPrice':
        updateRequest = updateSortFieldRequest(
          updateRequest,
          colSorted[0],
          'Price'
        );
        break;
      case 'digikeyPartNumber':
        updateRequest = updateSortFieldRequest(
          updateRequest,
          colSorted[0],
          'DigiKeyPartNumber'
        );
        break;
      case 'seriesName':
        updateRequest = updateSortFieldRequest(
          updateRequest,
          colSorted[0],
          'Series'
        );
        break;
      default:
        break;
    }

    const urlParamsSort = new URLSearchParams(new URL('', currentUrl).search);

    const decodedParams = new URLSearchParams(
      '?' + LZString.decompressFromEncodedURIComponent(urlParamsSort.get('s')!)
    );

    // For setting parameter for share link
    if (colSorted.length > 0) {
      decodedParams.set('colId', colSorted[0].colId);
      decodedParams.set('sort', colSorted[0].sort);
    } else {
      decodedParams.delete('colId');
      decodedParams.delete('sort');
    }

    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
    );

    setSearchQuery(updateRequest);
  };

  //For checking the checkbox from list checkbox when using share URL link
  //This life circle would be end up when table loaded
  useEffect(() => {
    if (!document.querySelector(`input[col-id='packageTypeCellRenderer']`)) {
      setBoxCheck(boxCheck + 1);
    } else {
      if (listCheckbox.length > 0) {
        listCheckbox.forEach((iCheckbox) => {
          const iElement = document.querySelector(
            `input[col-id="${iCheckbox}"]`
          );
          if (iElement) {
            (iElement as HTMLInputElement).checked = true;
          } else {
            setBoxCheck(boxCheck + 1);
          }
        });
      }
    }
  }, [boxCheck, isHorizontalView]);

  const onColumnEverythingChanged = (event: any) => {
    if (global.window.innerWidth < 900) {
      // Unpin columns on small device
      wrapperDataReturnDataForUnitTest(
        event?.columnApi?.applyColumnState({
          defaultState: { pinned: null }
        })
      );
    } else {
      // Pin columns on large device
      wrapperDataReturnDataForUnitTest(
        event?.columnApi?.applyColumnState({
          state: [
            {
              colId: 'manufacturerProductNumber',
              pinned: `${isReverse ? 'right' : 'left'}`
            }
          ],
          defaultState: { pinned: null }
        })
      );
    }
  };

  useEffect(() => {
    if (!isOrderByColumn) {
      columnApiRef.current?.resetColumnState();
    }
  }, [isOrderByColumn]);

  return (
    <>
      {
        <div className="ag-theme-alpine">
          {
            isHorizontalView ?
              <AgGridReact
                rowData={rowData}
                gridOptions={REVERSE_SEARCH_GRID_OPTIONS}
                columnDefs={appliedColumn.current}
                frameworkComponents={frameworkComponents}
                pinnedTopRowData={pinRowData}
                onSortChanged={handleSortChange}
                onFirstDataRendered={onFirstDataRendered}
                enableRtl={isReverse}
                onColumnEverythingChanged={onColumnEverythingChanged}
                onGridReady={function (params: any) {
                  setTimeout(function () {
                    let sourcePartRow: any =
                      document.querySelector('.ag-floating-top');
                    let sourcePartRowHeight: any =
                      document.querySelector('.ag-row-level-0');
                    try {
                      if (sourcePartRow && sourcePartRowHeight) {
                        const growHeight =
                          params.api.getPinnedTopRow(0).rowHeight + 0;
                        sourcePartRow.style.minHeight = growHeight + 'px';
                        sourcePartRow.style.height = growHeight + 'px';
                      }
                    } catch { }
                    params.api.resetRowHeights();
                    columnApiRef.current = params.columnApi;
                  }, 500);
                }}
                onDragStarted={onDragStarted}
                onDragStopped={onDragStopped}
              />
              :
              <VerticalViewTable
                columnDefs={columnDefs}
                pinRowData={pinRowData}
                isReverse={isReverse}
              />
          }
        </div>
      }
    </>
  );
};
